"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }// src/index.ts
var _wildcardmatch = require('@jswork/wildcard-match'); var _wildcardmatch2 = _interopRequireDefault(_wildcardmatch);
var defaults = {
  immediate: false,
  once: false
};
var getMatchedNames = function(inName, inMap) {
  const matchedTypes = [];
  if (inMap[inName]) matchedTypes.push(inName);
  Object.keys(inMap).forEach((eventType) => {
    if (_wildcardmatch2.default.call(void 0, eventType, inName)) {
      matchedTypes.push(eventType);
    }
  });
  return matchedTypes.filter((value, index, self) => self.indexOf(value) === index);
};
var getMatchedListeners = function(inName, inMap) {
  const allHandlers = [];
  const commonStarHandler = inMap["*"];
  if (inMap[inName]) {
    allHandlers.push(...inMap[inName]);
  } else {
    Object.keys(inMap).forEach((eventType) => {
      if (_wildcardmatch2.default.call(void 0, eventType, inName)) {
        allHandlers.push(...inMap[eventType]);
      }
    });
  }
  if (commonStarHandler) allHandlers.push(...commonStarHandler);
  return allHandlers;
};
var EventMitt = {
  _events: {},
  on: function(inName, inHandler, inOptions) {
    const self = this;
    const map = this._events = this._events || {};
    const options = Object.assign({}, defaults, inOptions || {});
    const listeners = map[inName] = map[inName] || [];
    listeners.push({ type: inName, handler: inHandler, options });
    if (options.immediate) inHandler.call(this);
    return {
      destroy: function() {
        self.off(inName, inHandler);
      }
    };
  },
  off: function(inName, inHandler) {
    const map = this._events = this._events || {};
    const matchedTypes = getMatchedNames(inName, map);
    matchedTypes.forEach((eventType) => {
      if (this._events[eventType]) {
        this._events[eventType] = this._events[eventType].filter((eventObj) => {
          if (!inHandler) return false;
          return eventObj.handler !== inHandler;
        });
        if (this._events[eventType].length === 0) {
          delete this._events[eventType];
        }
      }
    });
  },
  emit: function(inName, inData) {
    const map = this._events = this._events || {};
    const matchedHandlers = getMatchedListeners(inName, map);
    for (let i = 0; i < matchedHandlers.length; i++) {
      const eventObj = matchedHandlers[i];
      const args = eventObj.type.includes("*") ? [inName, inData] : [inData];
      if (eventObj.handler.apply(this, args) === false) {
        break;
      }
      if (eventObj.options.once) {
        this.off(inName, eventObj.handler);
      }
    }
  },
  one: function(inName, inHandler) {
    const self = this;
    const map = this._events = this._events || {};
    const evtMap = map[inName];
    if (!evtMap || !evtMap.length) {
      return this.on(inName, inHandler);
    }
    return {
      destroy: function() {
        self.off(inName, inHandler);
      }
    };
  },
  once: function(inName, inHandler) {
    return this.on(inName, inHandler, { once: true });
  },
  upon: function(inName, inHandler) {
    this.off(inName);
    return this.on(inName, inHandler);
  },
  on2immediate: function(inName, inHandler) {
    return this.on(inName, inHandler, { immediate: true });
  }
};
var mitt = () => Object.assign({}, EventMitt);
var src_default = EventMitt;



exports.default = src_default; exports.mitt = mitt;
